import { each } from 'lodash';
import { parseDate } from 'helpers/date_utils';

export const sortTasks = (tasks) => {
  const overdue = [];
  const completed = [];
  const notCompleted = [];

  each(tasks, (task) => {
    if (task.completedAt != null) {
      completed.push(task);
    } else if (task.dueDate && parseDate(task.dueDate) < new Date()) {
      overdue.push(task);
    } else {
      notCompleted.push(task);
    }
  });
  return notCompleted.reverse().concat(overdue).concat(completed);
};
